import React from 'react';
import {FormattedMessage, IntlProvider} from 'react-intl';

import * as ResourceApi from 'api/resources';
import {enUSmessage} from 'i18n/en-US.js';

export default {
    subSection: true,
    resource: false,
    hideIfResourceIsNoU: false,
    showSection: (formProxy) => {
        return formProxy.currentResource.resourceId.type === ResourceApi.Types.CustomJsonStep
    },

    fields: [
        // {
        //     type: 'contenteditable',
        //     name: 'label',
        //     required: true,
        //     // Headline is only allowed if there is more than one Custom HTML step
        //     // showField: (proxy) => (proxy.currentResource.type === 'CUSTOM_HTML' && proxy.currentBaseResource.steps && proxy.currentBaseResource.steps.length > 1),
        //     // linkedField: (formProxy) => ["title"],
        //     props: {
        //         labelKey: 'Label (used by dev)',                
        //     }
        // },
        // {
        //     type: 'textarea',
        //     name: 'customCss',
        //     // showField: (proxy) => (proxy.currentResource.type === 'CUSTOM_HTML'),

        //     props: {
        //         labelKey: 'editbreak.steps.custom_html.custom_css',
        //     }
        // },
        {
            type: 'textarea',
            name: 'customJson',
            // showField: (proxy) => (proxy.currentResource.type === 'CUSTOM_HTML'),

            props: {
                label: 'Step JSON',
            }
        }
    ]
}



// WEBPACK FOOTER //
// ./public/components/EditContent/configs/breaks/steps/custom-json.js